<div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="28px" [ngClass]="'card xs'">
  <div>
    <ifc-avatar-icon [data]="advisorData?.avatar"></ifc-avatar-icon>
  </div>
  <div fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="8px">
    <div fxLayout="column" class="secondary-text">
      <span class="mat-body-2">{{advisorData?.fullName}}</span>
      <span class="mat-subtitle-2">Business Advisor</span>
    </div>
    <div fxLayout="column" fxLayoutGap="12px">
      <div>
        <div (click)="$event.stopPropagation()">
          <a class="mat-body-1" href="{{mailLink(advisorData?.email)}}">{{advisorData?.email}}</a>
        </div>
        <span class="mat-body-1">{{advisorData?.displayPhone | phone}}</span>
      </div>
    </div>
  </div>
</div>
<div fxLayout="row" fxLayoutAlign="center center" class="layout padding-top-md">
  <button mat-stroked-button color="primary" (click)="calendarLink()">
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
      <mat-icon>phone_in_talk</mat-icon>
      <span>SCHEDULE A CALL</span>
    </div>
  </button>
</div>
